const initialState = {
  listVisit: [],
  listTemuanPest: [],
  kpi1: null,
  kpi2: null,
  calendar: [],
};

const pestRodentReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_LISTVISIT":
      return {
        ...state,
        listVisit: data,
      };
    case "SET_LISTTEMUANPEST":
      return {
        ...state,
        listTemuanPest: data,
      };
    case "SET_KPI1KUNJUNGAN":
      return {
        ...state,
        kpi1: data,
      };
    case "SET_KPI2TEMUAN":
      return {
        ...state,
        kpi2: data,
      };
    case "SET_CALENDAR":
      return {
        ...state,
        calendar: data,
      };
    default:
      return state;
  }
};

export default pestRodentReducer;
